import { render, staticRenderFns } from "./ProjectHeaderInfo.vue?vue&type=template&id=60c4e362&scoped=true&"
import script from "./ProjectHeaderInfo.vue?vue&type=script&lang=js&"
export * from "./ProjectHeaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHeaderInfo.vue?vue&type=style&index=0&id=60c4e362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c4e362",
  null
  
)

export default component.exports